import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import type { LocationTemplate } from '../models/LocationTemplate';
import type { Page_Union_VenueTemplate__LocationTemplate__ } from '../models/Page_Union_VenueTemplate__LocationTemplate__';
import type { TemplateUpdate } from '../models/TemplateUpdate';
import type { VenueTemplate } from '../models/VenueTemplate';
import { BaseHttpRequest } from '../core/BaseHttpRequest';



@Injectable({
  providedIn: 'root',
})
export class TemplateService {

	constructor(public readonly httpRequest: BaseHttpRequest) {}

	/**
	 * Get Templates
	 * @param page 
	 * @param pageSize 
	 * @returns Page_Union_VenueTemplate__LocationTemplate__ Successful Response
	 * @throws ApiError
	 */
	public getAll(
page: number = 1,
pageSize: number = 25,
): Observable<Page_Union_VenueTemplate__LocationTemplate__> {
				return this.httpRequest.request({
			method: 'GET',
			url: '/template',
			query: {
				page, page_size: pageSize
			},
			errors: {
				403: `Forbidden`,
				404: `Record Not Found`,
				409: `Record Already Exists`,
				422: `Validation Error`,
				500: `Internal Server Error`,
				502: `API Service is not currently online?`,
			},
		});
	}

	/**
	 * Get Template
	 * @param templateId 
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public get(
templateId: number,
): Observable<VenueTemplate | LocationTemplate> {
				return this.httpRequest.request({
			method: 'GET',
			url: '/template/{template_id}',
			path: {
				template_id: templateId
			},
			errors: {
				403: `Forbidden`,
				404: `Record Not Found`,
				409: `Record Already Exists`,
				422: `Validation Error`,
				500: `Internal Server Error`,
				502: `API Service is not currently online?`,
			},
		});
	}

	/**
	 * Delete Template
	 * @param templateId 
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public delete(
templateId: number,
): Observable<unknown> {
				return this.httpRequest.request({
			method: 'DELETE',
			url: '/template/{template_id}',
			path: {
				template_id: templateId
			},
			errors: {
				403: `Forbidden`,
				404: `Record Not Found`,
				409: `Record Already Exists`,
				422: `Validation Error`,
				500: `Internal Server Error`,
				502: `API Service is not currently online?`,
			},
		});
	}

	/**
	 * Update Template
	 * @param templateId 
	 * @param requestBody 
	 * @returns unknown Successful Response
	 * @throws ApiError
	 */
	public update(
templateId: number,
requestBody: TemplateUpdate,
): Observable<VenueTemplate | LocationTemplate> {
				return this.httpRequest.request({
			method: 'PUT',
			url: '/template/{template_id}',
			path: {
				template_id: templateId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				403: `Forbidden`,
				404: `Record Not Found`,
				409: `Record Already Exists`,
				422: `Validation Error`,
				500: `Internal Server Error`,
				502: `API Service is not currently online?`,
			},
		});
	}

}